// extracted by mini-css-extract-plugin
module.exports = {"default":"Caption-module__default___52l-8","bold":"Caption-module__bold___2rhvf","heavy":"Caption-module__heavy___3YTPc","medium":"Caption-module__medium___29QIs"};